module.exports = __webpack_public_path__ + "img/icon-right-red@3x.03c8c871.png";